import about from "./pages/about";
import dashboard from "./pages/dashboard";
import privacy from "./pages/privacy";
import terms from "./pages/terms";
// Import new page components
import costsAnalytics from "./pages/analytics/costs";
import ordersAnalytics from "./pages/analytics/orders";
import usageAnalytics from "./pages/analytics/usage";
import login from "./pages/auth/login";
import logout from "./pages/auth/logout";
import signup from "./pages/auth/signup";
import billing from "./pages/billing";
import pricing from "./pages/pricing";
import productLandingPage from "./pages/product-landing";
import profile from "./pages/profile";
import profileCompletion from "./pages/profile-completion";
import deliveryService from "./pages/services/delivery";
import storageService from "./pages/services/storage";
import settings from "./pages/settings";
import support from "./pages/support";
import apiDocs from "./pages/api-docs";
import integrations from "./pages/integrations";
import teamPage from "./pages/team/index";
import teamAcceptPage from "./pages/team/accept";
import multiStopBook from "./pages/multi-stop-book";
import routeSetEdit from "./pages/route-set-edit";

const routes = [
  { path: "/dashboard", component: dashboard },
  { path: "/book/multi-stop", component: multiStopBook },
  { path: "/route-set/:orderid", component: routeSetEdit },
  { path: "/terms", component: terms },
  { path: "/privacy", component: privacy },
  { path: "/about", component: about },
  { path: "/howitworks", component: about },
  { path: "/contact", component: about },
  { path: "/profile", component: profile },
  { path: "/profile-completion", component: profileCompletion },
  { path: "/settings", component: settings },
  { path: "/billing", component: billing },
  { path: "/support", component: support },
  { path: "/services/delivery", component: deliveryService },
  { path: "/services/storage", component: storageService },
  { path: "/pricing", component: pricing },
  { path: "/analytics/orders", component: ordersAnalytics },
  { path: "/analytics/usage", component: usageAnalytics },
  { path: "/analytics/costs", component: costsAnalytics },
  { path: "/login", component: login },
  { path: "/signup", component: signup },
  { path: "/product", component: productLandingPage },
  { path: "/logout", component: logout },
  { path: "/api-docs", component: apiDocs },
  { path: "/enterprise-api-docs", component: apiDocs },
  { path: "/partner-api-docs", component: apiDocs },
  { path: "/docs", component: apiDocs },
  { path: "/integrations", component: integrations },
  { path: "/team/accept", component: teamAcceptPage },
  { path: "/team", component: teamPage },
  { path: "/developers", component: integrations },
  { path: "/partner-plans", component: integrations },
  { path: "/widget", component: integrations },
  { path: "/", component: productLandingPage },
];

export default routes;
